import { render, staticRenderFns } from "./TransferredColumn.vue?vue&type=template&id=a999944e&"
import script from "./TransferredColumn.vue?vue&type=script&lang=js&"
export * from "./TransferredColumn.vue?vue&type=script&lang=js&"
import style0 from "./TransferredColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a999944e')) {
      api.createRecord('a999944e', component.options)
    } else {
      api.reload('a999944e', component.options)
    }
    module.hot.accept("./TransferredColumn.vue?vue&type=template&id=a999944e&", function () {
      api.rerender('a999944e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/TransferredColumn.vue"
export default component.exports